/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

const moduleName = 'match';
const componentName = 'ip-reputation-type-match';
const prefix = `${moduleName}.${componentName}`;

export const ipReputationTypeLabel = `${prefix}.ipReputationTypeLabel`;
export const ipReputationTypePlaceholder = `${prefix}.ipReputationTypePlaceholder`;

export const ENGLISH = {
    [ipReputationTypeLabel]: 'IP Reputation Type',
    [ipReputationTypePlaceholder]: 'Select IP Reputation Type',
};
